import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type ProjectState,
  patchProjectsProjectIDState,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

export function useUpdateProjectStateMutation(projectId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((state: ProjectState) =>
      patchProjectsProjectIDState(state, projectId),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.detail(projectId),
      });
    },
  });
}
